// src/utils/notify.js
import Swal from "sweetalert2";

export const notify = (message, type = "success", timer = 3000) => {
  Swal.fire({
    title: message,
    icon: type,
    timer,
    showConfirmButton: false,
    toast: true,
    position: "top-end",
  });
};
